module.exports = __webpack_public_path__ + "static/18-90d8f9b3d3ece029779804b3a5e3c7ff.mp4";